import { render, staticRenderFns } from "./RPVisitRegistry.vue?vue&type=template&id=190876f9&"
import script from "./RPVisitRegistry.vue?vue&type=script&lang=js&"
export * from "./RPVisitRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports